import React,{useEffect, useRef, useState} from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearSearched, searchAccounts, getReasonsClassified } from "../../../store/actions/precog";
import { AutoComplete } from "antd";
import { useIntl } from "react-intl";

const AccountAutocomplete = ({initialValue, rowId, isAccountingAccounts, isAccountingReason, registrationData, onChange}) => {
  const [timer, setTimer] = useState(null);
  const [newTitle, setNewTitle] = useState({ id: "", title: initialValue, description: initialValue });
  const [accounts, setAccounts] = useState([]);
  // const [defaultAccounts, setDefaultAccounts] = useState(initialValue);
  const searchedAccounts = useSelector(state => state.precog.searchAccounts.data);
  const dispatch = useDispatch();
  const refContiAutocomplete = useRef();

  useEffect(() => {
    // se ho un initialValue recupero la descrizione
    if (!initialValue) return;
    
    dispatch(searchAccounts(initialValue)).then((el)=>{
      const description = `${el.data.accounts?.[0]?.code} - ${el.data.accounts?.[0]?.description}`;
      const str = el.data.accounts?.[0]?.description;
      const str2 = `${el.data.accounts?.[0]?.code} - ${str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()}`;
      // setDefaultAccounts(`${el.data.accounts[0].code]} - ${el.data.accounts[0].description]}`)
      setNewTitle({ id: rowId, title: str2, description: description });
      /** Ho bisogno di recuperare la descrizione ma poi voglio la lista iniziale pulita */
      // non torna più la lista vuota, quindi questa chiamata non torna niente
      // dispatch(searchAccounts(""));
    });
  }, [initialValue]);

  useEffect(() => {

    const optionReasons = [];
    if (searchedAccounts?.accounts){
      searchedAccounts.accounts.forEach((el, index)  => {
        const labelCamel = el.description?.charAt(0).toUpperCase() + el.description?.slice(1).toLowerCase();
        optionReasons.push({value: `${el.code} - ${el.description}`, label:`${el.code} - ${labelCamel}`});
      });
    }
    setAccounts(optionReasons);
  }, [searchedAccounts]);

  useEffect(() => {
    /* NO BUENO
    if (newTitle?.title && newTitle.title.length > 2 && isAccountingAccounts) {
      setTimer(setTimeout(() => dispatch(searchAccounts(newTitle.title)), 500));
    }
    */
    if (newTitle?.title && newTitle.title.length > 2 && isAccountingReason) {
      setTimer(setTimeout(() => dispatch(getReasonsClassified(
        "BANK_TRANSACTION",
        newTitle.title,
        registrationData?.doc?.active ? "ACTIVE" : "PASSIVE"
      )), 500));
    }
    return (() => {
      clearTimeout(timer);
    });
  }, [newTitle]);

  const onSearch = (val) => {
    const str = val.toLowerCase();
    const str2 = str.charAt(0).toUpperCase() + str.slice(1);
    setNewTitle({ id: rowId, title: str2, description: val });
    
    setTimer(setTimeout(() => dispatch(searchAccounts(val)), 500));
  };

  const accountPlaceholder = useIntl().formatMessage({
    id: "preCog.fiscalPayments.searchLedgerAccount"
  });

  return (
    <AutoComplete
      ref={refContiAutocomplete}
      allowClear={true}
      popoverPlacement={"bottom"}
      getPopupContainer={trigger => trigger.parentNode}
      options={accounts}
      value={newTitle.title}
      filterOption={(inputValue, option) => {
        if (inputValue === newTitle.description) return true;
        return option.label.toUpperCase().indexOf(inputValue.toUpperCase())>-1;
      }
      }
      placeholder={accountPlaceholder}
      notFoundContent={"Nessun risultato"}
      onClear={e => {
        setNewTitle("");
        // setTimer(setTimeout(() => dispatch(searchAccounts("")), 500));
        refContiAutocomplete.current.focus();
      }}
      style={{ width: "100%" }}
      onSelect={ (e) => {
        onChange(e);
      } }
      onSearch={data => onSearch(data)}
      onChange={(el) => {
        const str = el?.toLowerCase();
        const str2 = str?.charAt(0)?.toUpperCase() + str?.slice(1);
        setNewTitle({ id: rowId, title: str2, description: el });
        dispatch(clearSearched());
      }
      }

    />
  );
};

export default AccountAutocomplete;
